export { default as SearchInput } from './searchInput'
